// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"d78e16fb","392":"41080645","412":"8681ab68","450":"c9269c13","458":"2ed78d20","468":"5ecf00e2","655":"7497a0ea","685":"e93c41df","718":"588da7b0","727":"e4a17e1a","840":"039d2b7b","882":"18fa7b25","885":"28a8c9d7"}[chunkId] + ".chunk.js";
};